// Linha do tempo viva: exibe as últimas mudanças do ecossistema absorvidas pela
// Camada de Sincronização Viva (GET /api/changelog). Só-leitura; poll leve ao abrir.

const escapeHtml = (s: string) =>
  String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c] as string));

export class Timeline {
  private list!: HTMLDivElement;
  private panel!: HTMLElement;

  mount(root: HTMLElement) {
    root.insertAdjacentHTML("beforeend", `
      <button id="tl-btn" class="panel" title="Linha do tempo viva">⟳</button>
      <div id="timeline" class="panel">
        <div class="tl-head"><h3>Linha do tempo viva</h3><button id="tl-close" title="fechar">×</button></div>
        <div id="tl-list" class="tl-list"><div class="tl-empty">carregando…</div></div>
      </div>`);
    this.panel = root.querySelector("#timeline") as HTMLElement;
    this.list = root.querySelector("#tl-list") as HTMLDivElement;
    (root.querySelector("#tl-btn") as HTMLElement).addEventListener("click", () => this.toggle());
    (root.querySelector("#tl-close") as HTMLElement).addEventListener("click", () => this.panel.classList.remove("open"));
  }

  toggle() {
    this.panel.classList.toggle("open");
    if (this.panel.classList.contains("open")) this.refresh();
  }

  async refresh() {
    try {
      const r = await fetch(`/api/changelog?t=${Date.now()}`, { cache: "no-store" });
      if (!r.ok) { this.list.innerHTML = `<div class="tl-empty">sincronização indisponível</div>`; return; }
      const { changelog } = await r.json();
      this.render(Array.isArray(changelog) ? changelog : []);
    } catch { this.list.innerHTML = `<div class="tl-empty">offline</div>`; }
  }

  private render(items: Array<Record<string, string>>) {
    if (!items.length) { this.list.innerHTML = `<div class="tl-empty">sem eventos ainda</div>`; return; }
    const icon: Record<string, string> = { created: "✦", updated: "↻", archived: "◦" };
    this.list.innerHTML = items.slice(0, 60).map((x) => {
      const when = x.at
        ? new Date(x.at).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
        : "";
      return `<div class="tl-row tl-${x.action}">
        <span class="tl-ic">${icon[x.action] ?? "·"}</span>
        <div class="tl-body">
          <span class="tl-lbl">${escapeHtml(x.label ?? x.node_id ?? "")}</span>
          <span class="tl-meta">${escapeHtml(x.gal ?? "")} · ${escapeHtml(x.scope ?? "")}</span>
        </div>
        <span class="tl-when">${when}</span>
      </div>`;
    }).join("");
  }
}
